/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import RepurchaseRateChart from './RepurchaseRateChart';

const RepurchaseRateShow = ({ dir, data, viewReportButton, title, optionShow, month }) => {
    const thisMonthData = {};
    if(optionShow?.value === 'monthly')
    {
        data.forEach((item) => {   
            if (item && thisMonthData[`${item.month}-${item.year}`]) {
                thisMonthData[`${item.month}-${item.year}`].push(item)
            } else {
                thisMonthData[`${item.month}-${item.year}`] = [item]
            }
                    
        })
    }
    else if(optionShow?.value === 'yearly')
    {
        data.forEach((item) => {   
            if (item.year && thisMonthData[item.year]) {
                thisMonthData[item.year].push(item)
            } else {
                thisMonthData[item.year] = [item]
            }
                    
        })
    }
    else if(optionShow?.value === 'quarterly')
    {
        data.forEach((item) => {   
            for( let i = 0; i < month.length; i += 1 )
            {
                const [month1, month2, month3] = month[i].split('-');
                if (item?.month === month1) {
                    if (item && thisMonthData[`${month[i]}`]) {
                        thisMonthData[`${month[i]}`].push(item)
                    } else {
                        thisMonthData[`${month[i]}`] = [item]
                    }
                }
                else if(item?.month === month2)
                {
                    if (item && thisMonthData[`${month[i]}`]) {
                        thisMonthData[`${month[i]}`].push(item)
                    } else {
                        thisMonthData[`${month[i]}`] = [item]
                    }
                }
                else if(item?.month === month3)
                {
                    if (item && thisMonthData[`${month[i]}`]) {
                        thisMonthData[`${month[i]}`].push(item)
                    } else {
                        thisMonthData[`${month[i]}`] = [item]
                    }
                }
            }       
        })
     
    }
 //   const max = currentMonthDayCount > prevMonthDayCount ? currentMonthDayCount : prevMonthDayCount;
    const reduceCallback = (acc, item) => acc + Number(item.totalCustomer)
    const reduceCallbackForRepeatCustomer = (acc, item) => acc + Number(item.repeatCustomer)
    const dataToPlot = []
    
    Object.keys((thisMonthData)).forEach((dayMonthYear) => {
        const totalCustomer = thisMonthData?.[dayMonthYear].reduce(reduceCallback, 0)
        const repeatCustomer = thisMonthData?.[dayMonthYear].reduce(reduceCallbackForRepeatCustomer, 0)
        const repurchaseRate = ((repeatCustomer * 100)/totalCustomer);
        dataToPlot.push({
            "day": dayMonthYear,            
            'RepurchaseRate': Number(repurchaseRate),            
        })
    })
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                <h5 className="bold-text col-md-5">{title}</h5>
                <div id='dvChartView'>
                    {viewReportButton?.()}</div>
                </div>

                {data?.length ? (
                    <RepurchaseRateChart
                        dataToPlot={dataToPlot}
                        height={400}
                        showTitle={false}
                        dir={dir}
                    />

                ) : 'No data to display'}
            </Card>
        </Col>

    )
}

RepurchaseRateShow.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    optionShow: PropTypes.object.isRequired,
    month: PropTypes.object.isRequired,
};

RepurchaseRateShow.defaultProps = {
    title: 'Repurchase Rate',
}

export default RepurchaseRateShow;
